import React from 'react'

import { Trans, useTranslation } from 'react-i18next'

import LinkButton from '@components/shared/LinkButton'
import PremiumPricing from '@features/compare-plans/PremiumPlanCard/PremiumPricing'
import { useSession } from '@stores/globalData/globalData.store'
import { getDollarsAndCentsFromPrice } from '@utils/formatters/number.formatter'
import PageRoutes from '@utils/page-routes'

import FeatureExpander from '../FeatureExpander'
import FeatureList from '../FeatureList'
import { FEATURES } from '../FeatureList/constants'
import PlanCard from '../PlanCard'

import type { PremiumPricingResponse } from '@pages/plans/plans.loader'

interface Props {
  premiumPricing: PremiumPricingResponse
}

const PremiumPlanCard: React.FC<Props> = ({ premiumPricing }) => {
  const { t } = useTranslation()
  const session = useSession()

  const premiumMonthly = getDollarsAndCentsFromPrice(premiumPricing.monthly_price)
  const premiumYearly = getDollarsAndCentsFromPrice(
    premiumPricing.promotion_price ?? premiumPricing.yearly_price
  )

  return (
    <PlanCard
      planType="premium"
      description={
        <Trans
          i18nKey="plans.premium.description"
          components={[<span className="font-semibold" key="0" />]}
        />
      }
      pricing={
        <PremiumPricing
          monthlyPrice={`${premiumMonthly.dollars}.${premiumMonthly.cents}`}
          yearlyPrice={premiumYearly.dollars}
        />
      }
      className="border-t-4 pt-5 pb-8 border-orange lg:pb-12">
      <LinkButton
        href={PageRoutes.purchaseAnnual()}
        external
        variant="primary"
        className="mb-1 w-full font-medium"
        size="lg">
        {t('plans.premium.action')}
      </LinkButton>
      <a
        href={PageRoutes.premiumTrialPath()}
        className="w-full p-2 text-center underline"
        title="premium trial">
        {t('plans.premium.trial')}
      </a>
      <FeatureExpander>
        <FeatureList features={FEATURES.premium(session.gatedFeatures.showAds())} />
      </FeatureExpander>
    </PlanCard>
  )
}

export default PremiumPlanCard
